/**
 * navigationSurfaces.js — C4d-3 semantic routing (02/09/2026).
 *
 * O backend emite destino SEMÂNTICO validado ({surface, params}) +
 * navigation_execution (metadata do BACKEND). O Router é responsabilidade
 * do frontend: este módulo é a ÚNICA ponte surface → rota.
 *
 * Whitelist pura, espelho de NAVIGATION_SURFACES do backend
 * (src/modules/mind/nav_execution.py). Unknown surface → null → NUNCA
 * navegar. Nunca usar payload.route raw como fallback de auto-nav.
 */

/**
 * @param {string} surface — destino semântico validado pelo backend
 * @param {{athlete_id?: number|string}} [params]
 * @returns {string|null} rota interna ou null (nunca navegar)
 */
export function surfaceToRoute(surface, params = {}) {
  switch (surface) {
    case 'training_builder':
      return '/treinos/novo';
    case 'training_plan_detail': {
      // C4d-3G: treino EXISTENTE. plan_id resolvido/autorizado pelo
      // backend — nunca do LLM, nunca URL crua.
      const pid = parseInt(params?.plan_id, 10);
      if (!Number.isFinite(pid) || pid <= 0) return null;
      return `/treinos/${pid}`;
    }
    case 'coach_training':
      return '/treinos';
    case 'athlete_detail':
    case 'athlete_wellness': {
      // wellness é seção da página do atleta (fotografia 02/09) —
      // mesma rota, alias honesto.
      const id = parseInt(params?.athlete_id, 10);
      if (!Number.isFinite(id) || id <= 0) return null;
      return `/coach/athlete/${id}`;
    }
    case 'squads':
      return '/coach/groups';
    case 'coach_performance':
      return '/coach/performance';
    case 'dashboard':
      return '/coach';
    default:
      return null;
  }
}

/**
 * Rota CTA segura para navigate SEM destino semântico (deploy skew /
 * backend antigo): aceita apenas path interno simples. Clique é humano,
 * mas nunca renderizamos CTA para URL externa/perigosa.
 * @param {string} route
 * @returns {string|null}
 */
export function safeInternalRoute(route) {
  if (typeof route !== 'string') return null;
  if (!/^\/[a-zA-Z0-9\-_/]*(\?[a-zA-Z0-9\-_=&]*)?$/.test(route)) return null;
  if (route.includes('..')) return null;
  return route;
}
